import { Injectable } from '@angular/core'
import { first } from 'rxjs/operators'

import { MapCurrentLocationAdapter } from './map-current-location-adapter'
import { googleMapConfig } from '@app/core/constants/config-map'
import { LatLng } from '@shared/models/latlng.model'
import { AbstractGoogleMapAdapter } from '@app/shared/services/abstract-google-map-adapter'

@Injectable()
export class MapCurrentLocationGoogleMapsService extends AbstractGoogleMapAdapter implements MapCurrentLocationAdapter {
  constructor() {
    super()
    this.loadMultipleExternalResources(googleMapConfig.googleMapLibrariesUrls)
      .pipe(first())
      .subscribe(() => this.setIsScriptLoaded(true))
  }

  setMarker(coordinate: LatLng) {
    const marker = new google.maps.Marker({ position: coordinate })
    marker.setMap(this.map)
  }
}
